// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BOU9n","buttons":"styles_buttons__sDsMs"};